import { Group, GroupMember } from "suus-api"
import { groupApi, groupMemberApi } from "store/api"

export const fetchGroups = async (
  client_id?: number,
  level_id?: number
): Promise<Group[]> => {
  const response = await groupApi.getGroups(
    undefined,
    level_id ?? undefined,
    client_id ?? undefined
  )
  const groups = response.data?.results
  return groups || []
}

export const fetchGroupMembers = async (
  searchParam: string,
  level_id: number
): Promise<GroupMember[]> => {
  const response = await groupMemberApi.getGroupMembers(searchParam, level_id)
  const members = response.data?.results
  return members || []
}
